import { AuthBaseClient } from '../base-client';
import type { ProviderSelectionSettings, UpdateProviderSelectionSettingsRequest } from './types';

/**
 * Client for the org-level provider-selection settings — the weights and
 * strategy mix that decide which providers a referral is offered to, and in
 * what order.
 *
 * Note there is no `simulate` method here: the ranked provider pool rides on
 * the EXISTING appointment-type simulate response
 * (`AppointmentTypeMatchingClient.simulate`), because it is a regrouping of
 * the same scored rows rather than a separate computation.
 */
export class ProviderSelectionClient extends AuthBaseClient {
  /**
   * Read the organization's settings. The server seeds a default row on first
   * read, so this never 404s for a valid org.
   */
  async getSettings(): Promise<ProviderSelectionSettings> {
    return this.get<ProviderSelectionSettings>('/api/provider-selection/settings');
  }

  /**
   * Persist settings. Partial — only the supplied fields change.
   */
  async updateSettings(
    data: UpdateProviderSelectionSettingsRequest
  ): Promise<ProviderSelectionSettings> {
    return this.put<ProviderSelectionSettings>('/api/provider-selection/settings', data);
  }
}
